export const MEDIA_BLOCK_SIZES = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
} as const;

export const sizeConfig = {
  container: {
    xs: "w-fit max-w-20",
    sm: "w-full",
    md: "w-full",
    lg: "w-full",
  },
  image: {
    xs: "h-20 w-20 object-cover",
    sm: "max-h-40",
    md: "max-h-80",
    lg: "max-h-[480px]",
  },
  video: {
    xs: "h-20 w-20 object-cover",
    sm: "max-h-40",
    md: "max-h-80",
    lg: "max-h-[480px]",
  },
  icon: {
    xs: "h-6 w-6 min-w-6",
    sm: "h-8 w-8 min-w-8",
    md: "h-12 w-12 min-w-12",
    lg: "h-16 w-16 min-w-16",
  },
  iconInner: {
    xs: "h-3 w-3 min-w-3",
    sm: "h-4 w-4 min-w-4",
    md: "h-6 w-6 min-w-6",
    lg: "h-8 w-8 min-w-8",
  },
  padding: {
    xs: "p-1.5",
    sm: "p-2",
    md: "p-3",
    lg: "p-4",
  },
  playButton: {
    xs: "h-6 w-6",
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12",
  },
  playIcon: {
    xs: "h-2.5 w-2.5",
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  },
};
